import { render, staticRenderFns } from "./_User_data.vue?vue&type=template&id=70a854b1&scoped=true&"
import script from "./_User_data.vue?vue&type=script&lang=js&"
export * from "./_User_data.vue?vue&type=script&lang=js&"
import style0 from "./_User_data.vue?vue&type=style&index=0&id=70a854b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a854b1",
  null
  
)

export default component.exports